import { jsonp, ajax } from '@ifeng-fe/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable */
let apiBaseUrl = apiUrl;

/* eslint-enable */
if (/\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

export const getQueryString = (paramKey, defaultV) => {
    let sURLVariables = '';
    let i = 0;
    let sParameterName = '';
    const sPageURL = window.location.search.substring(1);

    if (sPageURL.match(/&/)) {
        sURLVariables = sPageURL.split('&');
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === paramKey) return sParameterName[1];
        }
    } else {
        if (typeof defaultV !== 'undefined') return defaultV;

        sURLVariables = sPageURL.split('=');

        return sURLVariables[1];
    }

    return defaultV;
};

// 专题页页面信息
export const getIfengNewsTopicData = async params => {
    const data = await jsonp(
        `//c1.m.ifeng.com/TopicApiForCmpp?topicid=${params.topicid}&json=y&ad=y&gv=5.7.2&av=5.7.2`,
        {
            jsonpCallback: 'ifengNewsTopicCb',
            cache: true,
        },
    );

    return data ? data : null;
};

/**
 * 获取24h relative 列表数据
 * @param pageSize
 * @param pageNum
 */
export const getTFHoursList = async (key, pageNum = 1, pageSize = 6) => {
    const listData = await jsonp(`${apiBaseUrl}/tfhoursmodel/${key}/${pageNum}/${pageSize}/getTFHoursList`, {
        // jsonpCallback: `getTFHoursList${key}`,
        jsonpCallback: 'getTFHoursList',
        cache: 120,
    });

    const data = listData.data;

    if (!data) {
        return [];
    }

    // move to sever client for dealing
    // const listTemp = listData.data;

    // console.log('listTemp:', listTemp);

    // const data = listTemp.map(item => ({
    //     type: item.type || '',
    //     base62Id: item.base62Id || '',
    //     guid: item.guid || '',
    //     newStyle: item.newStyle,
    //     title: item.title || '',
    //     summary: item.summary || '',
    //     newsTime: item.newsTime,
    //     thumbnail:
    //         (item.thumbnails &&
    //             item.thumbnails.image &&
    //             item.thumbnails.image[0].url &&
    //             formatImage(item.thumbnails.image[0].url, 226, 150)) ||
    //         (item.thumbnail && formatImage(item.thumbnail, 226, 150)) ||
    //         '',
    //     url: item.url,
    // }));

    if (data && data.length > 0) {
        return data;
    } else {
        return [];
    }
};

// 专题页页面信息
export const getQaList = async (topicId, page, orderType) => {
    const callBackName = 'getQuestionDetailListCallback';
    let data = null;

    try {
        data = await jsonp(`${apiBaseUrl}/ishare/getWendaDetailList/${topicId}/${page}/${orderType}/${callBackName}`, {
            jsonpCallback: callBackName,
            cache: true,
        });
    } catch (e) {
        console.error(e);
    }

    return data;
};
